<template>
  <div :class="$style.ring" :style="ringStyle">
    <div :style="divStyle"></div>
    <div :style="divStyle"></div>
    <div :style="divStyle"></div>
    <div :style="divStyle"></div>
  </div>
</template>

<script>
export default {
  props: {
    size: {
      type: Number,
      default: 72,
    },
  },
  computed: {
    ringStyle () {
      return {
        width: `${this.size}px`,
        height: `${this.size}px`,
      }
    },
    divStyle () {
      return {
        width: `${this.size}px`,
        height: `${this.size}px`,
      }
    },
  },
}
</script>

<style lang="scss" module>
.ring {
  display: inline-block;
  position: relative;
  // width: 64px;
  // height: 64px;
}
.ring div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  // width: 51px;
  // height: 51px;
  // margin: 6px;
  border: 6px solid #D97143;
  border-radius: 50%;
  animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: #D97143 transparent transparent transparent;
}
.ring div:nth-child(1) {
  animation-delay: -0.45s;
}
.ring div:nth-child(2) {
  animation-delay: -0.3s;
}
.ring div:nth-child(3) {
  animation-delay: -0.15s;
}
@keyframes lds-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
